<template>
  <div class="mod-user-list">
    <div class="page-header">
      <span class="page-header__title">用户列表</span>
    </div>

    <div class="page-body">
      <!-- 筛选栏 -->
      <div class="toolbar">
        <el-input
          v-model="dataForm.keyword"
          placeholder="请输入内容"
          clearable
          class="toolbar__search"
          @keyup.enter.native="handleSearch">
          <el-select v-model="searchField" slot="prepend" class="toolbar__prepend">
            <el-option label="ID" value="memberCode"></el-option>
            <el-option label="账号" value="memberName"></el-option>
          </el-select>
        </el-input>
        <el-select
          v-model="dataForm.paid"
          placeholder="全部类型"
          clearable
          class="toolbar__select"
          @change="handleSearch">
          <el-option
            v-for="item in paidOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select
          v-model="dataForm.vipPeriod"
          placeholder="全部会员"
          clearable
          class="toolbar__select"
          @change="handleSearch">
          <el-option label="非会员" :value="0"></el-option>
          <el-option
            v-for="item in vipPeriodOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input
          v-model="dataForm.agentAccount"
          placeholder="上级代理"
          clearable
          class="toolbar__select"
          @keyup.enter.native="handleSearch"
          @clear="handleSearch">
        </el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
      </div>

      <!-- 用户表格 -->
      <div class="panel">
        <el-table :data="dataList" v-loading="loading" style="width: 100%;">
          <el-table-column prop="memberCode" label="ID" min-width="140"></el-table-column>
          <el-table-column label="账号" min-width="140">
            <template slot-scope="scope">{{ scope.row.memberName || '—' }}</template>
          </el-table-column>
          <el-table-column label="上级代理" min-width="130">
            <template slot-scope="scope">{{ scope.row.agentAccount || '—' }}</template>
          </el-table-column>
          <el-table-column label="类型" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isGuest ? 'info' : ''" size="small">
                {{ scope.row.isGuest ? '游客' : '注册' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="会员类型" min-width="110">
            <template slot-scope="scope">{{ vipTypeLabel(scope.row) }}</template>
          </el-table-column>
          <el-table-column label="到期时间" min-width="160">
            <template slot-scope="scope">{{ expireLabel(scope.row) }}</template>
          </el-table-column>
          <el-table-column label="IP" min-width="130">
            <template slot-scope="scope">{{ scope.row.ip || '—' }}</template>
          </el-table-column>
          <el-table-column prop="createTime" label="注册时间" min-width="160"></el-table-column>
          <el-table-column label="操作" width="170" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
              <el-button
                v-if="scope.row.vipPeriod !== foreverPeriod"
                type="text"
                size="small"
                @click="openVipDialog(scope.row)">
                {{ scope.row.memberVip ? '延期' : '开通会员' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handlePageChange">
        </el-pagination>
      </div>
    </div>

    <!-- 用户详情 -->
    <el-dialog :visible.sync="detailVisible" title="用户详情" width="640px">
      <el-descriptions :column="2" border v-loading="detailLoading">
        <el-descriptions-item label="用户号">{{ detail.memberCode || '—' }}</el-descriptions-item>
        <el-descriptions-item label="账号">{{ detail.memberName || '—' }}</el-descriptions-item>
        <el-descriptions-item label="昵称">{{ detail.memberNichen || '—' }}</el-descriptions-item>
        <el-descriptions-item label="会员类型">{{ vipTypeLabel(detail) }}</el-descriptions-item>
        <el-descriptions-item label="到期时间">{{ expireLabel(detail) }}</el-descriptions-item>
        <el-descriptions-item label="注册时间">{{ detail.createTime || '—' }}</el-descriptions-item>
        <el-descriptions-item label="金币数量">{{ detail.memberCion || 0 }}</el-descriptions-item>
        <el-descriptions-item label="提现余额">{{ detail.balance || 0 }}</el-descriptions-item>
        <el-descriptions-item label="上级ID">{{ detail.pid || '—' }}</el-descriptions-item>
        <el-descriptions-item label="IP">{{ detail.ip || '—' }}</el-descriptions-item>
        <el-descriptions-item label="修改密码" :span="2">
          <div class="password-field">
            <el-input
              v-model="newPassword"
              placeholder="填写后点保存即重置为新密码，留空不修改"
              size="small"
              class="password-field__input">
            </el-input>
            <el-button
              type="primary"
              size="small"
              :loading="passwordSaving"
              @click="submitPassword">保存</el-button>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="地址" :span="2">{{ detail.address || '—' }}</el-descriptions-item>
        <el-descriptions-item label="微信openid" :span="2">{{ detail.wxOpenid || '—' }}</el-descriptions-item>
      </el-descriptions>
      <template slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </template>
    </el-dialog>

    <!-- VIP 管理（复用用户模块弹窗） -->
    <vip-update v-if="vipVisible" ref="vipUpdate" @refreshDataList="loadList"></vip-update>
  </div>
</template>

<script>
import VipUpdate from '../user/user-vip-update'
import {
  getUserPage,
  getUserInfo,
  updateUser,
  VIP_PERIOD_MAP,
  VIP_PERIOD_OPTIONS,
  VIP_PERIOD_FOREVER,
  USER_PAID_TYPE,
  USER_PAID_OPTIONS
} from '@/api/userCenter'

export default {
  name: 'UserList',
  components: {
    VipUpdate
  },
  data () {
    return {
      loading: false,
      detailLoading: false,
      dataList: [],
      page: 1,
      limit: 10,
      total: 0,
      searchField: 'memberCode',
      dataForm: {
        keyword: '',
        paid: '',
        vipPeriod: '',
        agentAccount: ''
      },
      detailVisible: false,
      detail: {},
      newPassword: '',
      passwordSaving: false,
      vipVisible: false
    }
  },

  computed: {
    paidOptions () {
      return USER_PAID_OPTIONS
    },
    // 会员类型下拉（「非会员」单独列在前面）
    vipPeriodOptions () {
      return VIP_PERIOD_OPTIONS
    },
    // 终身会员不需要「延期」入口
    foreverPeriod () {
      return VIP_PERIOD_FOREVER
    }
  },

  created () {
    this.loadList()
  },

  methods: {
    loadList () {
      this.loading = true
      const params = {
        page: this.page,
        limit: this.limit
      }
      // 搜索字段由前置下拉决定，避免同时传两个条件导致互相排斥
      if (this.dataForm.keyword) {
        params[this.searchField] = this.dataForm.keyword
      }
      // 选「非会员」走 memberVip=0，其余按 vipPeriod 过滤
      if (this.dataForm.vipPeriod === 0) {
        params.memberVip = 0
      } else if (this.dataForm.vipPeriod !== '') {
        params.vipPeriod = this.dataForm.vipPeriod
      }
      // 用户类型由后端过滤：1=注册/付费 2=游客
      if (this.dataForm.paid !== '') {
        params.paid = this.dataForm.paid
      }
      if (this.dataForm.agentAccount) {
        params.agentAccount = this.dataForm.agentAccount.trim()
      }

      return getUserPage(params).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        const list = (res.data && res.data.list) || []
        this.total = (res.data && res.data.total) || 0
        this.dataList = list.map(item => ({
          ...item,
          // 接口返回 paid 就用它，否则按「有无账号」兜底判断
          isGuest: item.paid !== undefined && item.paid !== null
            ? Number(item.paid) === USER_PAID_TYPE.GUEST
            : !item.memberName
        }))
      }).catch(() => {
        this.$message.error('加载用户列表失败')
      }).finally(() => {
        this.loading = false
      })
    },

    handleSearch () {
      this.page = 1
      this.loadList()
    },

    handleSizeChange (val) {
      this.limit = val
      this.page = 1
      this.loadList()
    },

    handlePageChange (val) {
      this.page = val
      this.loadList()
    },

    openDetail (row) {
      this.detailVisible = true
      this.detail = { ...row }
      this.newPassword = ''
      this.loadDetail(row.memberCode)
    },

    loadDetail (memberCode) {
      this.detailLoading = true
      return getUserInfo(memberCode).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.detail = { ...this.detail, ...res.data }
      }).catch(() => {}).finally(() => {
        this.detailLoading = false
      })
    },

    // 与旧后台一致：整条用户数据带上 newPassword 提交，填了才改密码
    submitPassword () {
      const newPassword = (this.newPassword || '').trim()
      if (!newPassword) {
        return this.$message.warning('请输入新密码')
      }
      this.passwordSaving = true
      // isGuest 是列表里前端补的字段，不提交给后端
      const user = { ...this.detail, newPassword }
      delete user.isGuest
      updateUser(user).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success('密码修改成功')
        this.newPassword = ''
        this.loadDetail(this.detail.memberCode)
      }).catch(() => {
        this.$message.error('密码修改失败')
      }).finally(() => {
        this.passwordSaving = false
      })
    },

    openVipDialog (row) {
      this.vipVisible = true
      this.$nextTick(() => {
        this.$refs.vipUpdate.init(row.memberCode)
      })
    },

    vipTypeLabel (row) {
      if (!row || !row.memberVip) {
        return '非会员'
      }
      return VIP_PERIOD_MAP[row.vipPeriod] || '非会员'
    },

    expireLabel (row) {
      if (!row || !row.memberVip) {
        return '—'
      }
      // 终身会员没有到期时间
      if (row.vipPeriod === VIP_PERIOD_FOREVER) {
        return '永久'
      }
      return row.vipDate || '—'
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-user-list {
  background-color: #f5f7fa;
  min-height: 100%;
}

.page-header {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  background-color: #fff;
  border-bottom: 1px solid #ebeef5;

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2d3d;
  }
}

.page-body {
  padding: 16px;
}

.password-field {
  display: flex;
  align-items: center;

  &__input {
    flex: 1;
    margin-right: 8px;
  }
}

.toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  &__search {
    width: 320px;
    margin-right: 12px;
  }

  &__prepend {
    width: 100px;
  }

  &__select {
    width: 160px;
    margin-right: 12px;
  }

  &__tip {
    margin-left: 8px;
    color: #e6a23c;
    font-size: 16px;
  }
}

.panel {
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 0 16px 16px;
}

.pagination {
  margin-top: 16px;
  text-align: right;
}

::v-deep .el-table th {
  background-color: #fafbfc;
  color: #909399;
  font-weight: 500;
}

::v-deep .toolbar__prepend .el-input__inner {
  background-color: #f5f7fa;
}
</style>
